import { FC, useState } from 'react';
import { SimpleFAQsT } from '@components/Organisms/SimpleFAQs/types';
import { StyledSimpleFAQs } from '@components/Organisms/SimpleFAQs/styled/StyledSimpleFAQs';
import { SimpleFAQ } from '@components/Organisms/SimpleFAQs/SimpleFAQ';

export const SimpleFAQs: FC<SimpleFAQsT> = ({ display, title, items }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  if (!display) return null;

  return (
    <StyledSimpleFAQs>
      <h2>{title}</h2>
      <div className="md:mx-auto md:container">
        <div className="wrapper">
          {items.map((item, index) => (
            <SimpleFAQ
              key={`simple-faq-${index}`}
              index={index}
              faq={item}
              isActive={activeIndex === index}
              onClick={() => setActiveIndex(activeIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </StyledSimpleFAQs>
  );
};
